import { WorkStation } from '../../../shopfloor/workstations/work-station'
import { ControlTerminal } from '../../control-terminal'
import { WorkCenter } from '../../../shopfloor/workcenters/work-center'
import { TerminalWorkBatch } from './terminal-work-batch'

export class TerminalWorkBatchCtx {
  constructor(
    public terminal: ControlTerminal,
    public workCenter: WorkCenter,
    public workStation: WorkStation,
    public terminalBatch: TerminalWorkBatch
  ) {}
}
